var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _c(
        "template",
        { staticClass: "breadcrumb", slot: "breadcrumbs" },
        [_c("router-link", { attrs: { to: "/sectors" } }, [_vm._v("Sectors")])],
        1
      ),
      _vm._v(" "),
      _vm.sector
        ? _c("section", { staticClass: "vsector" }, [
            _c("header", { staticClass: "vsector__header" }, [
              _c(
                "div",
                { staticClass: "vsector__title" },
                [
                  _c("h1", {
                    attrs: { slot: "header" },
                    domProps: { textContent: _vm._s(_vm.sector.name) },
                    slot: "header",
                  }),
                  _vm._v(" "),
                  _vm.can("createMembers")
                    ? _c(
                        "router-link",
                        { attrs: { to: `/sectors/${_vm.sector.id}/edit` } },
                        [
                          _c("span", [_vm._v("Edit")]),
                          _vm._v(" "),
                          _c("SvgIcon", {
                            attrs: { icon: "edit", "is-filled": true },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vsector__actions" }),
            ]),
            _vm._v(" "),
            _c(
              "aside",
              { staticClass: "vsector__sidebar" },
              [
                _c("SectorCounts", { attrs: { "sector-id": _vm.selectedId } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vsector__sectors" },
                  [
                    _c("span", { staticClass: "subheading" }, [
                      _vm._v("Filter by subsector"),
                    ]),
                    _vm._v(" "),
                    _c("SectorViewFilters", {
                      attrs: {
                        "default-items": [
                          {
                            id: _vm.sector.id,
                            label: _vm.sector.name,
                            children: null,
                          },
                        ],
                        "default-sector-id": _vm.sector.id,
                        label: "Filter posts by...",
                      },
                      model: {
                        value: _vm.selectedId,
                        callback: function ($$v) {
                          _vm.selectedId = $$v
                        },
                        expression: "selectedId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.sector.leader
                  ? _c(
                      "div",
                      { staticClass: "vsector__leader" },
                      [
                        _c("span", { staticClass: "subheading" }, [
                          _vm._v("Sector Leader"),
                        ]),
                        _vm._v(" "),
                        _c("UserCard", {
                          attrs: {
                            user: _vm.sector.leader,
                            borderless: true,
                            small: true,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vsector__table" },
                  [
                    _c("h3", { staticClass: "subheading" }, [
                      _vm._v("Top Response Rate"),
                    ]),
                    _vm._v(" "),
                    _c("SectorLeagueTable", { attrs: { id: _vm.sector.id } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "vsector__feed" },
              [
                _c("span", {
                  staticClass: "subheading",
                  domProps: {
                    textContent: _vm._s(
                      `Post in the ${_vm.sector.name} sector`
                    ),
                  },
                }),
                _vm._v(" "),
                _c("CreatePost", {
                  ref: "createPostForm",
                  attrs: {
                    "sector-id": _vm.id,
                    "default-values": {
                      sectorOptions: [
                        {
                          id: _vm.sector.id,
                          label: _vm.sector.name,
                          children: null,
                        },
                      ],
                    },
                  },
                  on: {
                    created: _vm.handlePostCreated,
                    "form-submit": _vm.handlePostFormSubmit,
                  },
                }),
                _vm._v(" "),
                _c("SectorPostFeed", {
                  ref: "feed",
                  attrs: { "sector-ids": [_vm.selectedId] },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }